import { findProductComponent } from "../productComponents/findProductComponent";
import { ProductComponent } from "../../types/productComponent";
import Decimal from "decimal.js";
import { Product } from "../../types";
import { getDiscountPrice } from "../shared/getDiscountPrice";
import {getMarginPrice} from "../shared/getMarginPrice";

export function getPrice(
    component: ProductComponent, 
    components: ProductComponent[], 
    oldPrice: boolean = false,
    processedIds: Set<string> = new Set()
) : number {
    if (processedIds.has(component.id)) {
        throw new Error(`Circular dependency detected for component ${component.id}`);
    }

    const branchProcessedIds = new Set(processedIds);
    branchProcessedIds.add(component.id);
    
    const _price = oldPrice && component.oldprice < component.price ? component.oldprice : component.price;


    const discountPrice = getDiscountPrice(_price, component.discount);
    const marginPrice = getMarginPrice(discountPrice, component.margin);
    const componentsPrice = component.components.reduce((acc, subComponent) => {
        const component = findProductComponent(components, subComponent.id);
        if (!component) return acc;
        return acc + (getPrice(component, components, oldPrice, branchProcessedIds) * subComponent.qty);
    }, 0);

    const price = new Decimal(componentsPrice).add(marginPrice)

    return price.toNumber();
}
